// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1Xc32","actionsCol":"EnrolledClinics_actionsCol__3EjTu"};